import requests from '@/utils/requests';

/**
 * 缺陷响应时间
 * @param {*} data
 */
export function issueResponseTimeTeam(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/issueResponseTimeTeam',
    method: 'post',
    data
  });
}

/**
 * 缺陷响应时间
 * @param {*} data
 */
export function issueDevSolveTime(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/issueDevSolveTime',
    method: 'post',
    data
  });
}
/**
 * 缺陷转出率
 * @param {*} data
 */
export function queryIssueTurnOutNum(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/data/queryIssueTurnOutNum',
    method: 'post',
    data
  });
}
